module.exports = __webpack_public_path__ + "static/media/java.9c183012.png";